<script setup lang="ts">
import ImportantTerms from '@/components/ImportantTerms.vue';
</script>

<template>
    <ImportantTerms :path="['useraccount', 'settings']" :headerSize="5" size="small" class="mt-2_5rem"></ImportantTerms>
</template>
